export default "__VITE_ASSET__C0N4kzHP__"